// config/agingTableFilters.ts

import { FilterConfig } from "../../../../components/Tables/advancedRecord/FilterBar";
import { DropdownDTO } from "../../../../types/common/DropdownDTO";

export const getAgingTableFilters = (
  suppliersDropdown: DropdownDTO[]
): FilterConfig[] => {
  return [
    /**
     * 👤 Proveedor
     */
    {
      name: "supplierId",
      label: "Proveedor",
      type: "searchSelect",
      options: suppliersDropdown,
      colSpan: 6,
    },

    /**
     * 🚨 Solo alto riesgo
     */
    // {
    //   name: "highRiskOnly",
    //   label: "Solo alto riesgo (+90 días)",
    //   type: "checkbox",
    //   colSpan: 6,
    // },
  ];
};